module.exports = __webpack_public_path__ + "static/media/TagsGood.99cfe4f3.png";